import CommonImg from "@/components/Common/Img";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import ResetIcon from "@/assets/images/reset.png";
import { cn } from "@/libs/utils";

type Props = {
  onApply: (rowIndex: number) => void;
  rowIndex: number;
  isOwnProduct: boolean;
};

export default function ChangeTppProductAlert({
  onApply,
  rowIndex,
  isOwnProduct,
}: Props) {
  return (
    <AlertDialog>
      <AlertDialogTrigger>
        <CommonImg
          src={ResetIcon}
          alt="R"
          className={cn(
            "absolute top-1/2 transform -translate-y-1/2 right-6 opacity-0 group-hover:opacity-100 transition-opacity",
            {
              hidden: !isOwnProduct,
            }
          )}
        />
      </AlertDialogTrigger>
      <AlertDialogContent className="w-[639px] h-[222px] flex flex-col justify-between">
        <AlertDialogHeader className="flex flex-col gap-4">
          <AlertDialogTitle>타사 제품으로 분류하기</AlertDialogTitle>
        </AlertDialogHeader>
        <p className="text-lg text-gray-A font-normal text-center">
          부여된 태그를 제거하고 연관된 데이터를 삭제합니다.
        </p>
        <AlertDialogFooter>
          <AlertDialogCancel className="h-8 py-2 px-5 border border-gray-D bg-gray-E hover:bg-gray-E rounded-md text-sm text-gray-A font-semibold">
            취소하기
          </AlertDialogCancel>
          <AlertDialogAction
            className="h-8 py-2 px-5 border border-blue-B bg-blue-B hover:bg-blue-B rounded-md text-sm text-white font-semibold"
            onClick={() => onApply(rowIndex)}
          >
            변경하기
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
